import { StyledBubbleItem } from "./style";
import { Icon } from "components/icon/Icon";
import { Util } from "utils";

type AssistantBubbleProps = {
  content: string;
  originalText: string;
  createdAt: string;
  status?: "success" | "error";
};

const AssistantBubble = ({
  content,
  originalText,
  status,
  createdAt,
}: AssistantBubbleProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(originalText);
  };

  return (
    <StyledBubbleItem className="assistant-bubble-container">
      <div className={`assistant-bubble bubble ${status}`}>
        <div
          className="assistant-bubble-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>

      <div className="chatbot-button-container">
        {status !== "error" && (
          <div className="buttons">
            <button className="chatbot-button" onClick={handleCopy}>
              <Icon icon="Copy01" size={8} stroke="--text-gray-4" />
            </button>
          </div>
        )}

        <span className="created-at">{Util.getHHMM(createdAt)}</span>
      </div>
    </StyledBubbleItem>
  );
};

export default AssistantBubble;
